import React from "react"
import { Link } from "gatsby"
import styled from "styled-components"
const LinkContainer = ({ children, className, to,...props }) => {
  return to ? (
    <StyledLink className={className} to={to} {...props}>
      {children}
    </StyledLink>
  ) : (
    <Container className={className} {...props}>{children}</Container>
  )
}
const StyledLink = styled(Link)`
  text-decoration: none;
`
const Container = styled.div``
export default LinkContainer
